import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";
import AuthService from "../modules/auth/redux/AuthService";
import { API_URL } from "../../setup";



const user = AuthService.GetCurrentUser() != null ? AuthService.GetCurrentUser() : null;

const httpLink = new HttpLink({
  uri: API_URL.concat('/graphql/'),
});



const authLink = setContext((_, { headers }) => {
  const token = user != null ? user.token : ''
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      sessionGuid: user?.userData?.sessionGuid

    }
  }
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    //strinify
    graphQLErrors.forEach(({ message, path }) => {
      if (/not authorized/.test(message)) {
        localStorage.clear();
        document.location.reload()
      }
    });
  }
});

export const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    }
  },
  cache: new InMemoryCache(),
});